import { PageLocatorMap } from '../types/PageLocatorMap';

export const signInPinVerifyPage = {
  alert: {
    error: 'signin-pin-verify-page.alert.error',
    success: 'signin-pin-verify-page.alert.success',
  },
  footer: {
    root: 'signin-pin-verify-page.footer.root',
  },
  form: {
    h1: 'signin-pin-verify-page.form.heading1',
    h3: 'signin-pin-verify-page.form.heading3',
    pinInput1: 'signin-pin-verify-page.form.pin-input-1',
    pinInput2: 'signin-pin-verify-page.form.pin-input-2',
    pinInput3: 'signin-pin-verify-page.form.pin-input-3',
    pinInput4: 'signin-pin-verify-page.form.pin-input-4',
    pinInput5: 'signin-pin-verify-page.form.pin-input-5',
    pinInput6: 'signin-pin-verify-page.form.pin-input-6',
    pinInputError: 'signin-pin-verify-page.form.pin-error',
    resendPinLink: 'signin-pin-verify-page.form.resend-pin-link',
    root: 'signin-pin-verify-page.form.root',
  },
  header: {
    signUpLink: 'signin-pin-verify-page.header.signup-link',
  },
} as const satisfies PageLocatorMap;
